import { create } from 'zustand';
import { useProjectStore } from './projectStore.ts';

interface PlaybackState {
  currentTime: number;
  isPlaying: boolean;
  shuttleSpeed: number;

  play: () => void;
  pause: () => void;
  togglePlayback: () => void;
  seek: (time: number) => void;
  setShuttleSpeed: (speed: number) => void;
}

export const usePlaybackStore = create<PlaybackState>((set, get) => ({
  currentTime: 0,
  isPlaying: false,
  shuttleSpeed: 1,

  play: () => {

    const ps = useProjectStore.getState();
    if (!ps.project) return;
    const offset = ps.getViewOffset();
    const endTime = offset + ps.getViewDuration();
    const { currentTime } = get();
    if (currentTime >= endTime - 0.01 || currentTime <= offset) {
      // Chrome: rAF-based playback can stall when starting at exactly t=0;
      // nudge 10ms past the view start for reliable first-frame advance.
      set({ currentTime: offset + 0.01, isPlaying: true });
    } else {
      set({ isPlaying: true });
    }
  },

  pause: () => set({ isPlaying: false, shuttleSpeed: 1 }),

  togglePlayback: () => {
    if (get().isPlaying) {
      get().pause();
    } else {
      get().play();
    }
  },

  seek: (time) => {

    const ps = useProjectStore.getState();
    if (!ps.project) return;
    const offset = ps.getViewOffset();
    const dur = ps.getViewDuration();
    const upperBound = ps.activeSceneId !== null ? offset + dur - 0.001 : offset + dur;
    const clamped = Math.max(offset, Math.min(time, upperBound));
    set({ currentTime: clamped });
  },

  setShuttleSpeed: (speed) => set({ shuttleSpeed: speed }),
}));
